// StatusScreen.js
import React from "react";
import PropTypes from "prop-types";
import { FaCheckCircle } from "react-icons/fa";
import ActionButton from "./ActionButton";
import "./StatusScreen.css";

const StatusScreen = ({ title, status, onContinue, optionButtons }) => {
  return (
    <div className="status-container">
      {status === "success" && (
        <>
          <div className="status-icon">
            <FaCheckCircle size={100} color="var(--color-green)" />
          </div>
          {title && <div className="status-title">{title}</div>}
          <ActionButton label="Continue" onClick={onContinue} />
        </>
      )}

      {status === "error" && (
        <>
          <div className="error-emoji-container">
            {/* Your error emoji JSX here */}
          </div>
          {title && <div className="status-title">{title}</div>}
          <ActionButton label="Continue" onClick={onContinue} />
        </>
      )}

      {status === "option" && (
        <>
          <div className="error-emoji-container">
            {/* Same as the error emoji JSX */}
          </div>
          {title && <div className="status-title">{title}</div>}
          <div className="option-buttons">
            {optionButtons.map((button, index) => (
              <ActionButton
                key={index}
                label={button.label}
                onClick={button.onClick}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

StatusScreen.propTypes = {
  title: PropTypes.string.isRequired,
  status: PropTypes.oneOf(["success", "error", "option"]).isRequired,
  onContinue: PropTypes.func,
  optionButtons: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
    })
  ),
};

export default StatusScreen;